import { render, staticRenderFns } from "./CharityProjects.vue?vue&type=template&id=7993ceb4&scoped=true&"
import script from "./CharityProjects.vue?vue&type=script&lang=js&"
export * from "./CharityProjects.vue?vue&type=script&lang=js&"
import style0 from "./CharityProjects.vue?vue&type=style&index=0&id=7993ceb4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7993ceb4",
  null
  
)

export default component.exports